enum ToolsMenuType {

    News = "news",
    EconomicCalendar = "economicCalendar",
    TradingOpportunities = "tradingOpportunities",
    Lessons = "lessons",
    AccountSettings= "accountSettings",
    LiveChat = "liveChat",
}
export default ToolsMenuType;
